import React, { useState, useEffect } from "react";
import { about } from "../mock";

const About = () => {
  const photos = about.townPhotos || [];
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (photos.length <= 1) return;
    const id = setInterval(() => {
      setIdx((i) => (i + 1) % photos.length);
    }, 3500);
    return () => clearInterval(id);
  }, [photos.length]);

  return (
    <section id="o-mne" className="bg-campaign-cream py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        {/* Image slideshow */}
        <div className="relative order-2 lg:order-1">
          <div className="absolute -top-4 -left-4 w-full h-full bg-campaign-blue border-4 border-campaign-ink" />
          <div className="relative z-10 w-full h-[340px] sm:h-[440px] border-4 border-campaign-ink overflow-hidden">
            {photos.map((src, i) => (
              <img
                key={i}
                src={src}
                alt={`Ružomberok ${i + 1}`}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                  i === idx ? "opacity-100" : "opacity-0"
                }`}
              />
            ))}
            {/* indikátor - bodky pri málo fotkách, počítadlo pri mnohých */}
            {photos.length > 1 && photos.length <= 10 && (
              <div className="absolute bottom-3 left-3 z-20 flex gap-1.5">
                {photos.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    aria-label={`Fotka ${i + 1}`}
                    className={`h-2.5 border-2 border-campaign-ink transition-all ${
                      i === idx ? "w-6 bg-campaign-yellow" : "w-2.5 bg-campaign-cream"
                    }`}
                  />
                ))}
              </div>
            )}
            {photos.length > 10 && (
              <div className="absolute bottom-3 left-3 z-20 bg-campaign-ink text-campaign-cream font-display text-sm px-3 py-1.5 border-2 border-campaign-yellow tabular-nums">
                {idx + 1} / {photos.length}
              </div>
            )}
          </div>
          <div className="absolute z-20 -bottom-5 right-4 bg-campaign-yellow border-4 border-campaign-ink px-4 py-3 -rotate-2 shadow-brutal">
            <span className="font-display uppercase text-campaign-ink text-lg sm:text-xl">
              Náš Ružomberok
            </span>
          </div>
        </div>

        {/* Text */}
        <div className="order-1 lg:order-2">
          <h2 className="font-display text-4xl sm:text-6xl text-campaign-ink leading-none mb-6">
            {about.heading}
          </h2>
          {about.paragraphs.map((p, i) => (
            <p key={i} className="text-campaign-ink/85 text-base sm:text-lg leading-relaxed mb-4">
              {p}
            </p>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
